import React, { useEffect } from 'react';
import { Modal, Form, Input } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import _ from 'lodash';

export interface IFormModalProps extends FormComponentProps {
    visible: boolean;
    initialValues?: any;
    onSubmit: (val: any) => void;
    onClose: () => void;
}

const FormModal: React.FC<IFormModalProps> = ({
    visible,
    initialValues,
    form,
    onSubmit,
    onClose,
}) => {
    const {
        getFieldDecorator,
        setFieldsValue,
        validateFields,
        resetFields,
    } = form;

    useEffect(() => {
        _.isEmpty(initialValues)
            ? resetFields()
            : setFieldsValue(initialValues!);
    }, [initialValues]);

    useEffect(() => {
        if (!visible) {
            resetFields();
        }
    }, [visible]);

    const handleSubmit = () => {
        validateFields(async (errs, values) => {
            if (errs) {
                return;
            }
            console.log('values', values);

            onSubmit(values);
        });
    };

    return (
        <Modal
            visible={visible}
            title={initialValues?.id ? '编辑通知' : '新建通知'}
            width={'600px'}
            onCancel={onClose}
            onOk={handleSubmit}
        >
            <Form labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                {!!initialValues?.id && (
                    <Form.Item>{getFieldDecorator('id')}</Form.Item>
                )}
                <Form.Item label="主题">
                    {getFieldDecorator('title', {
                        rules: [
                            {
                                required: true,
                                message: '请输入主题',
                            },
                        ],
                    })(<Input maxLength={12} placeholder="请输入主题" />)}
                </Form.Item>
                <Form.Item label="url">
                    {getFieldDecorator('url', {
                        rules: [
                            {
                                required: true,
                                message: '请输入正确的url',
                                pattern: /^https?:\/\//,
                            },
                        ],
                    })(<Input placeholder="请输入url" />)}
                </Form.Item>
                <Form.Item label="说明">
                    {getFieldDecorator('notes', {
                        rules: [
                            {
                                required: true,
                                message: '请输入说明',
                            },
                        ],
                    })(<Input placeholder="请输入说明" />)}
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default Form.create<IFormModalProps>()(FormModal);
